import CategoryController from '@/controllers/Category/CategoryController';

const state = {
  categories: null,
  total_new_questions: null,
};

const getters = {
  categories(state) {
    let categories = state.categories;
    if (!categories) categories = JSON.parse(localStorage.getItem('categories'));
    return categories;
  },
  total_new_questions(state) {
    return state.total_new_questions;
  },
};

const mutations = {
  setCategories(state, data) {
    if (data) {
      state.categories = data;
      state.total_new_questions = state.categories.filter((category) => {
        return Object.keys(category.new_questions).length > 0;
      });
      localStorage.setItem('categories', JSON.stringify(data));
      localStorage.setItem('total_new_questions', JSON.stringify(state.total_new_questions));
    }
  },
};

const actions = {
  async retrieveCategories({ commit, getters }) {
    let categories = await getters.categories;
    if (!categories) categories = await CategoryController.index();
    await commit('setCategories', categories);
    return categories;
  },
  async refreshCategories({ commit }) {
    let categories = await CategoryController.index();
    await commit('setCategories', categories);
    return categories;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
